export default function MobileComponent(){
    return <div>MobileComponent</div>
}